'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.hasStringTranslation = undefined;

var _I18n = require('I18n');

var _I18n2 = _interopRequireDefault(_I18n);

var _getLangLocale = require('I18n/utils/getLangLocale');

var _getLangLocale2 = _interopRequireDefault(_getLangLocale);

var _getLang = require('I18n/utils/getLang');

var _getLang2 = _interopRequireDefault(_getLang);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// This a hacky string util to determine if translations for a string exist
// We can't use I18n.lookup or I18n's isValidI18nKey
// bc those will return true if the English string exists, regardless of if the translation exists
var hasStringTranslation = exports.hasStringTranslation = function hasStringTranslation(stringKey) {
  var keys = stringKey.split('.');

  var lookupStringByLangCode = function lookupStringByLangCode(langCode) {
    var stringPath = _I18n2.default.translations[langCode];
    if (!stringPath) return false;

    var _iteratorNormalCompletion = true;
    var _didIteratorError = false;
    var _iteratorError = undefined;

    try {
      for (var _iterator = keys[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
        var key = _step.value;

        if (!stringPath[key]) return false;
        stringPath = stringPath[key];
      }
    } catch (err) {
      _didIteratorError = true;
      _iteratorError = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion && _iterator.return) {
          _iterator.return();
        }
      } finally {
        if (_didIteratorError) {
          throw _iteratorError;
        }
      }
    }

    return stringPath;
  };

  return !!lookupStringByLangCode((0, _getLangLocale2.default)()) || !!lookupStringByLangCode((0, _getLang2.default)());
};


//////////////////
// WEBPACK FOOTER
// ./js/utils/stringUtils.js
// module id = 311
// module chunks = 3 4